const DIALOGS_CHANNEL = 'DialogChannel'
const NOTIFICATIONS_COUNTER = 'NotificationCounter'
const MESSAGES_CHANNEL = 'DirectMessageChannel'

export default {
  DIALOGS_CHANNEL,
  NOTIFICATIONS_COUNTER,
  MESSAGES_CHANNEL
}
